import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../../../../../graphql/fragments/generated/User';
export type UserCollectionFragment = { id: string, name: string, type: Types.GroupTypeEnum, createdAt: string, updatedAt: string, isAutoSyncGroup: boolean, usersCount: number, createdBy?: { id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null } | null, sampleUsers: Array<{ id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null }> };


export type UserCollectionFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const UserCollectionFragmentDoc = /*#__PURE__*/ gql`
    fragment UserCollection on UserCollectionGroupType {
  id
  name
  type
  createdAt
  updatedAt
  createdBy {
    ...User
  }
  isAutoSyncGroup
  usersCount
  sampleUsers {
    ...User
  }
}
    `;